import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  appointmentStatusCreateRequest,
  appointmentStatusCreateSuccess,
  appointmentStatusDeleteRequest,
  appointmentStatusDeleteSuccess,
  appointmentStatusListRequest,
  appointmentStatusUpdateRequest,
  appointmentStatusUpdateSuccess,
  appointmentTypeCreateRequest,
  appointmentTypeCreateSuccess,
  appointmentTypeDeleteRequest,
  appointmentTypeDeleteSuccess,
  appointmentTypeListRequest,
  appointmentTypeUpdateRequest,
  appointmentTypeUpdateSuccess,
} from "../../../../store/appointment/action";
export default function AppointmentSettings() {
  const dispatch = useDispatch();

  const { appointmentTypeListAPI, appointmentStatusListAPI } = useSelector(
    (state) => ({
      appointmentTypeListAPI:
        state.Appointment.appointmentTypeList?.appointmenttype_list,
      appointmentStatusListAPI:
        state.Appointment.appointmentStatusList?.appointmentstatus_list,
    })
  );

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(appointmentStatusCreateRequest([createStatus]));
    }
    if (activeTab === "2") {
      // Task Type create
      dispatch(appointmentTypeCreateRequest([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = appointmentStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = appointmentTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [appointmentTypeListAPI, appointmentStatusListAPI, activeTab]);

  useEffect(() => {
    dispatch(appointmentStatusListRequest());
    dispatch(appointmentTypeListRequest());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Statuses",
    },
    {
      id: "2",
      name: "Types",
    },
    // {
    //     id: "3",
    //     name: "Priorities",
    // },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete

      dispatch(appointmentStatusDeleteRequest([deleteStatus]));
    }
    if (activeTab === "2") {
      // Task Type delete
      dispatch(appointmentTypeDeleteRequest([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update
        dispatch(appointmentStatusUpdateRequest([updateNewStatus]));
      }
      if (activeTab === "2") {
        // Task Type update
        dispatch(appointmentTypeUpdateRequest([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    appointmentTypeCreateSuccessAPI,
    appointmentTypeUpdateSuccessAPI,
    appointmentTypeDeleteSuccessAPI,
    appointmentStatusCreateSuccessAPI,
    appointmentStatusUpdateSuccessAPI,
    appointmentStatusDeleteSuccessAPI,
  } = useSelector((state) => ({
    appointmentTypeCreateSuccessAPI: state.Appointment.appointmentTypeCreate,
    appointmentTypeUpdateSuccessAPI: state.Appointment.appointmentTypeUpdate,
    appointmentTypeDeleteSuccessAPI: state.Appointment.appointmentTypeDelete,
    appointmentStatusCreateSuccessAPI:
      state.Appointment.appointmentStatusCreate,
    appointmentStatusUpdateSuccessAPI:
      state.Appointment.appointmentStatusUpdate,
    appointmentStatusDeleteSuccessAPI:
      state.Appointment.appointmentStatusDelete,
  }));

  // Create type effect
  useEffect(() => {
    if (isEmpty(appointmentTypeCreateSuccessAPI)) return;
    if (appointmentTypeCreateSuccessAPI?.status === 200) {
      toast.success(appointmentTypeCreateSuccessAPI.message);
      dispatch(appointmentTypeListRequest());
    } else {
      toast.error(appointmentTypeCreateSuccessAPI.message);
    }
    dispatch(appointmentTypeCreateSuccess([]));
  }, [appointmentTypeCreateSuccessAPI]);
  // Update type effect
  useEffect(() => {
    if (isEmpty(appointmentTypeUpdateSuccessAPI)) return;
    if (appointmentTypeUpdateSuccessAPI?.status === 200) {
      toast.success(appointmentTypeUpdateSuccessAPI.message);
      dispatch(appointmentTypeListRequest());
    } else {
      toast.error(appointmentTypeUpdateSuccessAPI.message);
    }
    dispatch(appointmentTypeUpdateSuccess([]));
  }, [appointmentTypeUpdateSuccessAPI]);
  // Delete type effect
  useEffect(() => {
    if (isEmpty(appointmentTypeDeleteSuccessAPI)) return;
    if (appointmentTypeDeleteSuccessAPI?.status === 200) {
      toast.success(appointmentTypeDeleteSuccessAPI.message);
      dispatch(appointmentTypeListRequest());
      setDeleteModal(false);
    } else {
      toast.error(appointmentTypeDeleteSuccessAPI.message);
    }
    dispatch(appointmentTypeDeleteSuccess([]));
  }, [appointmentTypeDeleteSuccessAPI]);
  // Create status effect
  useEffect(() => {
    if (isEmpty(appointmentStatusCreateSuccessAPI)) return;
    if (appointmentStatusCreateSuccessAPI?.status === 200) {
      toast.success(appointmentStatusCreateSuccessAPI.message);
      dispatch(appointmentStatusListRequest());
    } else {
      toast.error(appointmentStatusCreateSuccessAPI.message);
    }
    dispatch(appointmentStatusCreateSuccess([]));
  }, [appointmentStatusCreateSuccessAPI]);
  // Update status effect
  useEffect(() => {
    if (isEmpty(appointmentStatusUpdateSuccessAPI)) return;
    if (appointmentStatusUpdateSuccessAPI?.status === 200) {
      toast.success(appointmentStatusUpdateSuccessAPI.message);
      dispatch(appointmentStatusListRequest());
    } else {
      toast.error(appointmentStatusUpdateSuccessAPI.message);
    }
    dispatch(appointmentStatusUpdateSuccess([]));
  }, [appointmentStatusUpdateSuccessAPI]);
  // Delete status effect
  useEffect(() => {
    if (isEmpty(appointmentStatusDeleteSuccessAPI)) return;
    if (appointmentStatusDeleteSuccessAPI?.status === 200) {
      toast.success(appointmentStatusDeleteSuccessAPI.message);
      dispatch(appointmentStatusListRequest());
      setDeleteModal(false);
    } else {
      toast.error(appointmentStatusDeleteSuccessAPI.message);
    }
    dispatch(appointmentStatusDeleteSuccess([]));
  }, [appointmentStatusDeleteSuccessAPI]);
  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Appointment Settings"
        description="Statuses and types for appointments."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
        />
      </SettingsPanel>
    </>
  );
}
